/**
 * Mixin con los métodos comunes de google analytics
 * @type {Object}
 */
var appMixinAnalytics = {
  methods: {
    sendAnalyticsEventWithInmuebleItem(eventName, item) {
      var eventDimensions = {
        tipoInmueble: item.tipoBien,
        provincia: item.provincia,
        municipio: item.municipio,
        estado: item.estado,
        referencia: item.referencia,
        promocion: item.nombrePromocion
      };

      this.sendAnalyticsEventWithInmuebleDimensions(eventName, eventDimensions);
    },
    sendAnalyticsEventWithQueryInfo(eventName, query) {
      // query: tipo_bien=suelo residencial&provincia=cadiz&municipio=chipiona&oferta=s&referencia=368-pr-co -01
      var eventParams = {
        tipoInmueble: query.tipo_bien,
        provincia: query.provincia,
        municipio: query.municipio,
        estado: this.formatOferta2Label(query.oferta),
        referencia: query.referencia,
        promocion: query.promocion,
        busqueda: query.busqueda
          ? query.busqueda
          : query.BUSQUEDA
          ? query.BUSQUEDA
          : ""
      };

      this.sendAnalyticsEventWithInmuebleDimensions(eventName, eventParams);
    },
    formatOferta2Label(oferta) {
      if (oferta) {
        return oferta.toLowerCase() === "s" ? "en venta" : "consultar";
      } else {
        return "";
      }
    },
    sendAnalyticsEventWithInmuebleDimensions(eventName, eventParams) {
      var eventCategory = this.eventCategory4EventName(eventName);

      var eventDimensions = {
        tipoInmueble: eventParams.tipoInmueble
          ? eventParams.tipoInmueble.toLowerCase()
          : "- sin valor -",
        provincia: eventParams.provincia
          ? eventParams.provincia.toLowerCase()
          : "- sin valor -",
        municipio: eventParams.municipio
          ? eventParams.municipio.toLowerCase()
          : "- sin valor -",
        estado: eventParams.estado
          ? eventParams.estado.toLowerCase()
          : "- sin valor -",
        referencia: eventParams.referencia
          ? eventParams.referencia.toLowerCase()
          : "- sin valor -",
        promocion: eventParams.promocion
          ? eventParams.promocion.toLowerCase()
          : "- sin valor -"
      };

      var eventLabel = eventDimensions ? JSON.stringify(eventDimensions) : "{}";

      if (eventParams.busqueda) {
        eventLabel = "{ busqueda: " + eventParams.busqueda + "}";
      }

      // Lo comento por si no es necesario hacerlo si están creadas ya las variables
      this.$gtag.customMap({
        dimension1: "tipoInmueble",
        dimension2: "provincia",
        dimension3: "municipio",
        dimension4: "estado",
        dimension5: "referencia",
        dimension6: "promocion"
      });

      this.$gtag.event(eventName, {
        event_category: eventCategory,
        event_label: eventLabel,
        tipoInmueble: eventDimensions.tipoInmueble,
        provincia: eventDimensions.provincia,
        municipio: eventDimensions.municipio,
        estado: eventDimensions.estado,
        referencia: eventDimensions.referencia,
        promocion: eventDimensions.promocion
      });

      // console.log(
      //   "sendAnalyticsEventWithInmuebleDimensions",
      //   eventName,
      //   eventLabel,
      //   eventCategory,
      //   eventLabel,
      //   eventDimensions
      // );
    },
    eventCategory4EventName(eventName) {
      var categoria = "- sin categoria - "; // Por defecto por si no hay ninguna definidad

      var eventCategoriesMap = {
        inmueble_consultado: "interesado",
        click_en_estoy_interesado: "interesado",
        click_en_contactar: "interesado",
        click_en_ver_ficha: "comportamiento_usuario",
        click_en_play_video: "comportamiento_usuario",
        consulta_enviada_con_exito: "interesado",
        click_en_enlace_telefonos_sedes: "interesado",
        busqueda_realizada_con_filtros: "busqueda",
        busqueda_realizada_con_texto: "busqueda",
        click_en_paginacion_listado: "comportamiento_usuario",
        click_en_aplicar_filtro: "comportamiento_usuario",
        click_en_eliminar_filtro: "comportamiento_usuario",
        click_en_portada_buscador_con_filtro: "comportamiento_usuario",
        click_en_ir_detalle_marker_desde_mapa: "comportamiento_usuario",
        click_en_ir_detalle_marker_desde_listado: "comportamiento_usuario"
      };

      if (eventCategoriesMap[eventName]) {
        categoria = eventCategoriesMap[eventName];
      }

      return categoria;
    }
  }
};

export default appMixinAnalytics;
